<template>
  <div class="navigation-bar">
    <div class="logo-container">
<!--      <div v-if="appType === 'mbs'" class="logo-text">MBS Order Manager by</div>-->
      <router-link v-if="deviceType !== 'mobile' || isSlotEmpty('titleText')" to="overview" class="link logo">
        <div class="logo-image-container" v-if="!expanded">
          <img :src="logo" alt="Logo">
        </div>
      </router-link>
    </div>
    <div class="nav-bar-title" id="companyName">
      <slot name="titleText"></slot>
    </div>
    <div class="icons-container" :class="{'is-active': localIsMenuActive}">
      <slot name="iconsContainer"></slot>
      <div class="nav-button">
        <b-dropdown aria-role="menu" :triggers="['click']" position="is-bottom-left" append-to-body>
          <template #trigger="{ active }">
            <div class="dropdown-control">
              <fa :icon="menuIcon" size="xl" :style="{color: profileIconColor}"></fa>
              <div class="nav-button-text">Hi, {{ userName }}</div>
            </div>
          </template>
          <b-dropdown-item v-if="showFeedbackLink" aria-role="menuitem">
            <router-link to="feedback" @click.native="closeMenu">
              <div class="menu-button">
                <fa icon="comment-dots" size="sm" :style="{color: menuButtonIconColor}"></fa>
                <div class="nav-button-text has-text-black">Feedback</div>
              </div>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item aria-role="menuitem">
            <div @click="signOut" class="menu-button">
              <fa icon="arrow-right-from-bracket" size="sm" :style="{color: menuButtonIconColor}"></fa>
              <div class="nav-button-text has-text-black">Sign Out</div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="burger-container" @click="toggleMenu" v-if="deviceType === 'mobile'">
      <fa :icon="localIsMenuActive ? 'arrow-right' : 'bars'" size="2xl" :style="{color: profileIconColor}"></fa>
    </div>
  </div>
</template>
<script>
import ProfileCircle from 'component/core/profile-circle';
import HelpDesk from "../help-desk/component.vue";


export default {
  name: 'navigation-bar',
  components: {
    'profile-circle': ProfileCircle,
    HelpDesk,
  },
  props: {
    appType: {
      type: String,
      required: true
    },
    profileIconColor: {
      type: String,
      default: 'white',
    },
    isMenuActive: {
      type: Boolean,
      default: false
    },
    menuIcon: {
      type: String,
      default: 'caret-down'
    },
    menuButtonIconColor: {
      type: String,
      default: '#000'
    },
    iconLibrary: {
      type: String,
      default: 'mdi'
    },
    showFeedbackLink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expanded: false,
      searchTerm: '',
      localIsMenuActive: this.isMenuActive,
    }
  },
  watch: {
    isMenuActive(val) {
      this.localIsMenuActive = val;
    }
  },
  computed: {
    icon() {
      switch (this.expanded) {
        case true:
          return 'times';
        case false:
          return 'search';
      }
    },
    logo() {
      switch (this.appType) {
        case 'mbs':
          return 'img/mbs-new-logo.webp';
        case 'branch-portal':
          return 'img/project-estimator-logo.svg';
        case 'co-pilot':
          return 'img/project-estimator-logo.svg';
        case 'click-v2':
          return 'img/project-estimator-logo.svg';
        case 'external-supplier':
          return 'img/project-estimator-logo.svg';
      }
    },
    deviceType() {
      return this.$store.state.device.type;
    },
    isSaving() {
      const companyId = _.get(this.$store.getters['company/selectedCompany'], '_id', null);
      return this.$store.getters['company/isSaving'](companyId, 'requestCallback') ?? false;
    },
    isDev() {
      return this.$store.getters['user/isDev'];
    },
    userName() {
      return _.split(this.$store.getters['user/name'], ' ')[0] || 'Unknown';
    },
    showSearchBar() {
      return this.$store.getters['generic/showSearchBar'];
    },
    companyName() {
      return this.$store.getters['company/selectedCompany']?.name;
    }
  },
  methods: {
    signOut() {
      this.closeMenu();
      this.$store.dispatch('user/signOut', 'email');
    },
    toggleMenu() {
      // Emit an event to the parent to change the value of the prop
      this.$emit('update:isMenuActive', !this.localIsMenuActive);
    },
    closeMenu() {
      // Emit an event to the parent to change the value of the prop
      this.$emit('update:isMenuActive', false);
    },
    isSlotEmpty(slotName) {
      return !this.$slots[slotName] || (this.$slots[slotName].length >= 1 && this.$slots[slotName][0]?.text.trim().length === 0);
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-bar {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: $nav-bar-background-color;
  height: 90px;
  z-index: 39;

  @include tablet--large {
    position: fixed;
    display: flex;
    top: auto;
    bottom: 0;
    left: 0;
    height: 70px;
    justify-content: flex-start;
    border-top: 1px solid $white;
  }

  @media screen and (min-width: $tablet--large) {
    justify-content: center;
    width: auto;
  }

  .logo-container {
    padding-left: 0.7em;
    display: flex;
    gap: $double-padding;

    @media screen and (min-width: $tablet--large) {
      flex: 1;
      min-width: 264px;
    }

    .logo-text {
      color: $nav-bar-color;
      font-size: 2.5em;
      font-weight: bold;
    }

    .link {
      max-width: 65%;
      display: flex;

      &.logo {
        :hover {
          background-color: transparent !important;
        }
      }
    }
  }

  .nav-bar-title {
    @include tablet--large {
      padding-left: 10px;
    }

    @media screen and (min-width: $tablet--large) {
      display: flex;
      align-items: center;
      justify-content: center;

      .field {
        min-width: 60%;
      }
    }
  }

  #companyName {
    font-size: 2.5em;
    color: $nav-bar-color;
    display: flex;
    flex-wrap: nowrap;
    font-weight: bold;

    // Weird breakpoint for it to fit nicely on the navbar
    @media screen and (max-width: 1300px) {
      font-size: 1.750rem;
    }

    @media screen and (min-width: $tablet--large) {
      justify-content: center;
    }
  }

  .burger-container {
    @include tablet--large {
      position: fixed;
      bottom: 15px;
      right: 20px;
      z-index: 40;
    }
  }

  .icons-container {
    display: flex;
    gap: 2em;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0.7em;

    @media screen and (min-width: $tablet--large) {
      flex: 1;
    }

    @include tablet--large {
      position: fixed;
      bottom: 0;
      right: 0;
      transform: translate(100%, -16%);
      transition: transform 0.3s, opacity 0.3s;
      width: 30%;
      max-width: 8em;
      background-color: $primary;
      border-radius: 10px 0 0 0;
      border-top: 1px solid $white;
      border-left: 1px solid $white;
      flex-direction: column-reverse;
      justify-content: center;
      padding-block: 10px;
      z-index: 39;
      margin: 0;
      opacity: 0;

      &.is-active {
        transform: translate(1%, -16%);
        opacity: 1;
      }

      & > * {
        flex: 1;
      }
    }

    .profile-button {
      &:hover {
        cursor: pointer;
      }

    }
  }

  .nav-button {
    height: 55px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    max-width: 100px;
    cursor: pointer;
    flex-direction: column;
    overflow: hidden;
    padding-block: 7px;
    padding-inline: 5px;
    position: relative;
    border-radius: 4px;

    &:hover {
      @media screen and (min-width: $tablet--large) {
        animation: background-fill 200ms linear forwards;
      }
    }

    @include tablet--large {
      margin-right: 0;
    }

    .dropdown-control {
      height: 55px;
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      max-width: 100px;
      flex-direction: column;
      overflow: hidden;
      padding-top: 7px;
      padding-bottom: 7px;
      position: relative;
    }

    .nav-button-text {
      font-weight: 700;
      font-size: 14px;
      color: $nav-bar-color;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      line-height: 0.9;
      text-align: center;
      flex-grow: 1;
    }
  }

  .logo-image-container {
    @include desktop {
      width: 15em;
    }

    @media screen and (min-width: $tablet--large) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70px;
      width: 100%;
      max-width: 247px;
      position: absolute;
      top: 10px;
    }
  }
}

.menu-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  & > * {
    color: $nav-dropdown-color;
  }
}

.icon-transition-enter-active, .icon-transition-leave-active {
  transition: all 0.3s ease;
}

.icon-transition-enter-to, .icon-transition-leave {
  transform: scale(1.5);
  opacity: 0;
}

.navigation-bar-transition-enter-active, .navigation-bar-transition-leave-active {
  transition: all 0.3s ease;
}

.navigation-bar-transition-enter, .navigation-bar-transition-leave-to {
  transform: scaleY(0);
}

@keyframes background-fill {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: $nav-button-hover-background; // Final background color
  }
}
</style>